import { z } from "zod"

import * as m from "@/paraglide/messages"

export const forgotPasswordSchema = z.object({
  email: z.string().trim().min(1, m.signup_error_email_required()).pipe(z.email(m.signup_error_email_invalid())),
})

export const resetPasswordSchema = z.object({
  password: z.string().min(6, m.error_password_too_short({ count: 6 })).max(128, m.error_field_too_long({ count: 128 })),
  passwordConfirmation: z.string(),
}).refine((values) => values.password === values.passwordConfirmation, {
  path: ["passwordConfirmation"],
  message: m.error_password_confirmation(),
})

export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>
